import { get, set, cloneDeep, merge } from 'lodash-es'
import { set as vueSet } from 'vue'
import { pgMessage } from '../components/index'
/**
获取对象值
obj={
			obj:{
			code:"abc"
		};

path="obj.code"
=>
return "abc"
*/
export function getValueByPath(obj, path, defaultValue) {
  return get(obj, path, defaultValue)
}

export function getValueByPathNotNull(obj, path, defaultValue = null) {
  let tempValue = getValueByPath(obj, path, defaultValue)
  if (tempValue || tempValue === 0 || tempValue === false) {
    return tempValue
  } else {
    return defaultValue
  }
}

// 去除字符串中的换行符
export function removeNewLine(str) {
  if (!str) return str
  if (typeof str !== 'string') return str
  return str.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/"/g, '\\"')
}
/**
深度设值：
obj={};
path="obj.code";
value="abc"

=>
return {
			obj{
			code:"abc"
		}
};
*/
export function setValueByPath(obj, path, value) {
  return set(obj, path, value)
}

/**
vue响应式数据深度设值
如果obj中没有该属性则会使用深度赋值
*/
export function setValueByPathToVue(obj, path, value) {
  const setVal = (source, keys, val) => {
    const [fristKey, ...otherKeys] = keys
    const fristVal = getValueByPath(source, fristKey, 'NULL')
    if (otherKeys.length === 0 && fristVal === 'NULL') {
      vueSet(source, fristKey, val)
    } else if (otherKeys.length === 0 && fristVal !== 'NULL') {
      setValueByPath(source, fristKey, val)
    } else if (fristVal === 'NULL') {
      const tempVal = set({}, otherKeys.join('.'), val)
      vueSet(source, fristKey, tempVal)
    } else if (!fristVal) {
      const tempVal = set({}, otherKeys.join('.'), val)
      setValueByPath(source, fristKey, tempVal)
    } else {
      setVal(fristVal, otherKeys, val)
    }
  }

  const paths = path.split('.')
  setVal(obj, paths, value)
  return obj
}

/**
      删除属性
*/
export function deleteByPath(obj, path) {
  var tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')
  var keyArr = path.split('.')
  var i = 0
  for (var len = keyArr.length; i < len - 1; ++i) {
    var key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      return null
    }
  }
  if (tempObj && keyArr[i]) delete tempObj[keyArr[i]]
}

/**
   （包含或判断）获取对象值，判断 在数组中包含任意数据则返回true
 * @param {object} path 对象
 * @param {String} path 属性名
 @param {array or string} containArray 数组 或字符串
 * @return {boolean}

 用法：objectUtil.containOrValueByPath(data,'status.code',['DRAFT','REJECT'])

模板表达式用法:
{{$imports.objectUtil.containOrValueByPath(data,'status.code',['DRAFT','REJECT'])}}

*/
export function containOrValueByPath(obj, path, containArray) {
  var objValue = getValueByPath(obj, path, null)
  if (!containArray) return true
  if (containArray instanceof Array) {
    for (var i = 0; i < containArray.length; i++) {
      if (containArray[i] == objValue)
        // 如果要求数据类型也一致，这里可使用恒等号===
        return true
    }

    return false
  } else {
    return containArray == objValue
  }
}

export function clone(obj) {
  return cloneDeep(obj)
}

// 生成不重复的ID
export function createID() {
  const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  return `${S4()}-${S4()}-${S4()}-${S4()}`
}

//遍历合并对象
export function mergeObj(...arg) {
  return merge(...arg)
}

export function copyDataMethod(content, createIDKey = '_ID') {
  if (!content) {
    alert('没有选中数据')
    return false
  }
  if (createIDKey && Array.isArray(content)) {
    content = clone(content).map((item) => {
      if (item[createIDKey]) {
        item[createIDKey] = createID()
      }
      return item
    })
  }
  let strContent = JSON.stringify(content)
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.value = strContent
  input.select()
  document.execCommand('Copy', false)
  input.remove()
  pgMessage.success('复制成功')
}
